<div class="container-fluid">
  @if (currentTimeColumn === 'Contribution Finish') {
    <p style="text-align: right; margin: 0px;"><b>{{'Assess.lblTimeToClose' | translate}}</b></p>
  }
  @if (currentTimeColumn === 'Contribution Start') {
    <p style="text-align: right; margin: 0px;"><b>{{'Assess.lblTimeToOpen' | translate}}</b></p>
  }
  <p style="text-align: right; margin: 0px;">{{timeToOpenOrClose}}</p>
  <h4>{{assessMarket.marketCode}} {{'Assess.header' | translate}}</h4>

  <app-contribution-summary (getContributions)="GetContributions()"  (checkOverrideWindow)="CheckOverrideWindow()"></app-contribution-summary>
  @if (assessMarket.isMarketOpen === true && assessMarket.isAllowedUser === true) {
    <div  [@slider]="assessMarket.isMarketOpen === true && assessMarket.isAllowedUser === true? 'show' : null" class="slider">
      <div id="assessTable" class="mat-elevation-z6 mt-3">
        <form>
          <table mat-table [dataSource]="dataSourceNew">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef style="width: 20%; font-size: 16px;"> {{'Assess.thName' | translate}}</th>
              <td mat-cell *matCellDef="let element" [style.color]="element.notes.trim() !== '' ? (element.instrumentAccepted ? 'green' : 'red') : ''">{{element.instrumentDescription}}</td>
            </ng-container>
            <ng-container matColumnDef="assessedRate">
              <th mat-header-cell *matHeaderCellDef style="width: 10%; font-size: 16px;"> {{'Assess.thAssessedRate' | translate}}</th>
              <td mat-cell *matCellDef="let element"><mat-label [style.color]="element.notes.trim() !== '' ? (element.instrumentAccepted ? 'green' : 'red') : ''"> {{element.assessedRate}} </mat-label></td>
            </ng-container>
            <ng-container matColumnDef="assessedVolume">
              <th mat-header-cell *matHeaderCellDef style="width: 10%; font-size: 16px;"> {{'Assess.thAssessedVolume' | translate}}</th>
              <td mat-cell *matCellDef="let element"><mat-label [style.color]="element.notes.trim() !== '' ? (element.instrumentAccepted ? 'green' : 'red') : ''"> {{element.assessedVolume}} </mat-label></td>
            </ng-container>
            <ng-container matColumnDef="currentRate">
              <th mat-header-cell *matHeaderCellDef style="width: 10%; font-size: 16px;"> {{'Assess.thCurrentRate' | translate}}</th>
              <td mat-cell *matCellDef="let element" [style.color]="element.notes.trim() !== '' ? (element.instrumentAccepted ? 'green' : 'red') : ''">{{element.rate}}</td>
            </ng-container>
            <ng-container matColumnDef="currentVolume">
              <th mat-header-cell *matHeaderCellDef style="width: 10%; font-size: 16px;"> {{'Assess.thCurrentVolume' | translate}}</th>
              <td mat-cell *matCellDef="let element" [style.color]="element.notes.trim() !== '' ? (element.instrumentAccepted ? 'green' : 'red') : ''">{{element.volume}}</td>
            </ng-container>
            <ng-container matColumnDef="comments">
              <th mat-header-cell *matHeaderCellDef style="font-size: 16px;"> {{'Assess.thComments' | translate}}</th>
              <td mat-cell *matCellDef="let element" [style.color]="element.notes.trim() !== '' ? (element.instrumentAccepted ? 'green' : 'red') : ''">{{element.comments}}</td>
            </ng-container>
            <ng-container matColumnDef="notes">
              <th mat-header-cell *matHeaderCellDef style="width: 20%; font-size: 16px;"> {{'Assess.thNotes' | translate}}</th>
              <td mat-cell *matCellDef="let element">
                <input (focusout)="OnClickAction()"  class="tableInput {{(element.accepted === 'false') && (!element.newNotes) ? 'hasError' : ''}}" matInput type="text" [(ngModel)]="element.newNotes" [ngModelOptions]="{standalone: true}" />
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef style="width: 10%;"></th>
              <td mat-cell *matCellDef="let element">
                <div style="text-align: center;">
                  <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [(ngModel)]="element.accepted" [ngModelOptions]="{standalone: true}" style="height: 30px; align-items: center;" (change)="OnClickAction()" [disabled]="!assessMarket.canAssess">
                    <mat-button-toggle value="true"><i style="font-size: 1em;" class="fa fa-check text-success" aria-hidden="true"></i></mat-button-toggle>
                    <mat-button-toggle value="null"><i style="font-size: 1em;" class="fa fa-question" aria-hidden="true"></i></mat-button-toggle>
                    <mat-button-toggle value="false"><i style="font-size: 1em;" class="fa fa-times text-danger" aria-hidden="true"></i></mat-button-toggle>
                  </mat-button-toggle-group>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="loading">
              <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'tblLoading' | translate}}... </th>
            </ng-container>
            <ng-container matColumnDef="noData">
              <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'Assess.tblNoData' | translate}}...
              </th>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumns;"   matTooltip="{{row.notes}}"></tr>
            <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSourceNew!=null}"></tr>
            <tr mat-footer-row *matFooterRowDef="['noData']"
            [ngClass]="{'hide':dataSourceNew!=null && instrumentLength != 0}"></tr>
          </table>
        </form>
      </div>
      @if (instrumentLength > 0 && service.currentUser.isReadOnly === false) {
        <div style="margin: 10px;">
          <!-- <button mat-raised-button style="float: right; margin-left: 10px;" color="primary" type="button" (click)="OnAcceptClick()">{{'Assess.btnAccept' |
        translate}}</button>&nbsp;&nbsp;
        <button mat-raised-button style="float: right;" color="warn" type="button" (click)="OnRejectClick()">{{'Assess.btnReject' |
        translate}} </button> -->
        <button [disabled]="!canEnableSubmit || !assessMarket.canAssess" mat-raised-button style="float: right; margin-left: 10px;" color="primary" type="button" (click)="OnSubmitClick()">{{'btnSubmit' |
        translate}}</button>
      </div>
    }
  </div>
}
@if (assessMarket.isMarketOpen === false && assessMarket.isAllowedUser === true) {
  <div [@slider]="assessMarket.isMarketOpen === false && assessMarket.isAllowedUser === true? 'show' : null" class="slider">
    <p>{{'Assess.notReady' | translate}}</p>
  </div>
}
@if (assessMarket.isAllowedUser === false  && isLoading === false) {
  <div [@slider]="assessMarket.isAllowedUser === false  && isLoading === false? 'show' : null" class="slider">
    <p>{{'Assess.notAllowed' | translate}}</p>
  </div>
}
@if (isLoading === true) {
  <div [@slider]="isLoading === true? 'show' : null" class="slider">
    <p>{{'tblLoading' | translate}}...</p>
  </div>
}
</div>
